import { useEffect, useState } from 'react';
import './site-styles';

const LINKS = [
  { href: '#mission', label: 'Our Mission' },
  { href: '#approach', label: 'Our Approach' },
  { href: '#contact', label: 'Contact' },
];

export default function SiteNav() {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <>
      <header className={`site-nav ${solid ? 'is-solid' : ''}`}>
        <a className="wordmark" href="#top" aria-label="The Reve Foundation home">
          <span className="name">The Reve Foundation</span>
          <span className="tag">Philanthropy with Purpose</span>
        </a>

        <nav className="links" aria-label="Primary">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href}>
              {l.label}
            </a>
          ))}
        </nav>

        <a className="nav-cta" href="#contact">
          Contact Us
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </a>

        <button
          type="button"
          className="burger"
          aria-label="Open menu"
          aria-expanded={open}
          onClick={() => setOpen(true)}
        >
          <i className="ri-menu-line" aria-hidden="true" />
        </button>
      </header>

      <div className={`nav-sheet ${open ? 'is-open' : ''}`} aria-hidden={!open}>
        <div className="sheet-head">
          <span className="sheet-name">The Reve Foundation</span>
          <button
            type="button"
            className="burger"
            aria-label="Close menu"
            onClick={() => setOpen(false)}
          >
            <i className="ri-close-line" aria-hidden="true" />
          </button>
        </div>
        <nav className="sheet-links" aria-label="Mobile">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}>
              {l.label}
            </a>
          ))}
        </nav>
        <div className="sheet-foot">
          <a href="mailto:sherri@therevefoundation.com">sherri@therevefoundation.com</a>
          <br />
          550 Hamilton Ave, Palo Alto, CA 94301
        </div>
      </div>
    </>
  );
}